var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoVtAdmin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 68,
    viewBox: "0 0 256 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7073_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.573 46.6872H142.455L132.872 20.8779H139.74L145.604 39.1813H145.748L151.577 20.8779H158.335L148.573 46.6872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.251 26.1972V46.6872H165.133V26.1972H157.983V20.872H178.407V26.1972H171.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.654 39.5045V34.767H185.735V39.5045H176.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85 40.927C191.04 41.8498 191.455 42.6198 192.101 43.2252C192.747 43.8306 193.542 44.1362 194.494 44.1362C195.255 44.1362 195.883 43.9893 196.373 43.6954C196.864 43.4074 197.25 43.0077 197.532 42.514C197.821 42.0143 198.023 41.4324 198.138 40.7624C198.259 40.0923 198.317 39.3811 198.317 38.6287V20.872H201.857V38.7757C201.857 39.675 201.759 40.6213 201.574 41.6205C201.384 42.6198 201.027 43.5426 200.502 44.389C199.977 45.2412 199.245 45.9407 198.305 46.505C197.359 47.0634 196.149 47.3396 194.672 47.3396C192.741 47.3396 191.173 46.8282 189.956 45.8114C188.739 44.7887 187.944 43.4779 187.563 41.8733L190.85 40.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.34 33.7443C233.34 35.7369 232.999 37.5649 232.319 39.2283C231.639 40.8917 230.705 42.3259 229.511 43.5308C228.317 44.7358 226.899 45.6703 225.256 46.3404C223.607 47.0105 221.819 47.3455 219.887 47.3455C217.956 47.3455 216.174 47.0105 214.542 46.3404C212.911 45.6703 211.498 44.7358 210.304 43.5308C209.111 42.3317 208.182 40.8917 207.514 39.2283C206.845 37.5649 206.51 35.7369 206.51 33.7443C206.51 31.7517 206.845 29.8826 207.514 28.2192C208.182 26.5558 209.111 25.1334 210.304 23.9519C211.498 22.7764 212.911 21.8594 214.542 21.2011C216.174 20.5428 217.962 20.2137 219.887 20.2137C221.813 20.2137 223.607 20.5428 225.256 21.2011C226.899 21.8594 228.317 22.7764 229.511 23.9519C230.699 25.1334 231.639 26.5558 232.319 28.2192C232.999 29.8826 233.34 31.7282 233.34 33.7443ZM229.511 33.7443C229.511 32.3336 229.286 31.0053 228.831 29.7533C228.381 28.5013 227.735 27.4022 226.899 26.4559C226.063 25.5095 225.054 24.7631 223.878 24.2106C222.701 23.6639 221.369 23.3935 219.887 23.3935C218.406 23.3935 217.114 23.6639 215.938 24.2106C214.756 24.7572 213.752 25.5095 212.934 26.4559C212.115 27.4081 211.475 28.5013 211.019 29.7533C210.564 31.0053 210.339 32.3395 210.339 33.7443C210.339 35.1491 210.564 36.5245 211.019 37.7941C211.469 39.0578 212.115 40.157 212.951 41.0915C213.787 42.0261 214.79 42.7608 215.955 43.2957C217.12 43.8306 218.434 44.101 219.887 44.101C221.34 44.101 222.667 43.8365 223.86 43.2957C225.054 42.7608 226.069 42.0261 226.899 41.0915C227.729 40.157 228.375 39.0578 228.831 37.7941C229.286 36.5245 229.511 35.1785 229.511 33.7443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.166 20.872H246.89C247.841 20.872 248.798 20.9837 249.75 21.2011C250.701 21.4186 251.554 21.783 252.304 22.2944C253.054 22.8058 253.665 23.4758 254.126 24.2987C254.593 25.1275 254.824 26.1561 254.824 27.3963C254.824 28.8305 254.414 30.0354 253.607 31.0053C252.794 31.981 251.722 32.6452 250.39 33.0096V33.086C251.197 33.18 251.952 33.3916 252.644 33.7267C253.336 34.0558 253.936 34.4849 254.432 35.0198C254.933 35.5547 255.32 36.1836 255.591 36.9183C255.862 37.653 256 38.4583 256 39.3576C256 40.5978 255.752 41.6793 255.25 42.6021C254.749 43.5249 254.074 44.2832 253.215 44.8827C252.356 45.4764 251.347 45.9289 250.194 46.2287C249.04 46.5344 247.806 46.6872 246.492 46.6872H238.16V20.872H238.166ZM241.706 31.7753H246.319C246.988 31.7753 247.628 31.6988 248.233 31.5401C248.839 31.3814 249.369 31.1405 249.825 30.8113C250.28 30.4821 250.638 30.0707 250.897 29.5711C251.157 29.0715 251.289 28.4719 251.289 27.7666C251.289 26.3795 250.787 25.392 249.79 24.7925C248.787 24.1988 247.443 23.899 245.748 23.899H241.706V31.7753ZM241.706 43.6249H246.14C246.878 43.6249 247.622 43.5543 248.377 43.425C249.127 43.2898 249.807 43.0547 250.413 42.7138C251.018 42.3729 251.508 41.9144 251.877 41.3443C252.246 40.7741 252.431 40.0512 252.431 39.1754C252.431 37.6472 251.918 36.5363 250.891 35.8544C249.865 35.1726 248.389 34.8317 246.457 34.8317H241.7V43.6249H241.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4192 46.7518L0 68H3.2924L13.7116 46.7518H10.4192Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3713 21.2482L28.8647 46.746H32.1514L44.6579 21.2482H41.3713Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2182 21.2482L36.6374 0H33.3508L22.9258 21.2482H26.2182Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2756 46.7518L36.8506 68H40.143L50.5622 46.7518H47.2756Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2218 21.2482L65.7153 46.746H69.0077L81.5142 21.2482H78.2218Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0689 21.2482L73.4938 0H70.2014L59.7822 21.2482H63.0689Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1262 46.7518L73.707 68H76.9937L87.4186 46.7518H84.1262Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.078 21.2482L102.566 46.746H105.859L118.365 21.2482H115.078Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9252 21.2482L110.344 0H107.058L96.6328 21.2482H99.9252Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3186 43.137C13.3771 43.137 9.35815 39.0343 9.35815 33.9971C9.35815 28.9598 13.3771 24.8571 18.3186 24.8571C23.26 24.8571 27.2847 28.9598 27.2847 33.9971C27.2847 39.0343 23.26 43.137 18.3186 43.137Z",
    fill: "url(#paint0_linear_7073_46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.175 43.137C50.2335 43.137 46.2088 39.0343 46.2088 33.9971C46.2088 28.9598 50.2277 24.8571 55.175 24.8571C60.1222 24.8571 64.1412 28.9598 64.1412 33.9971C64.1412 39.0343 60.1222 43.137 55.175 43.137Z",
    fill: "url(#paint1_linear_7073_46)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0257 43.137C87.0842 43.137 83.0595 39.0343 83.0595 33.9971C83.0595 28.9598 87.0784 24.8571 92.0257 24.8571C96.9729 24.8571 100.986 28.9598 100.986 33.9971C100.986 39.0402 96.9671 43.137 92.0257 43.137Z",
    fill: "url(#paint2_linear_7073_46)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7073_46",
    x1: 9.18829,
    y1: 43.7089,
    x2: 67.1877,
    y2: 82.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#208AC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7073_46",
    x1: 9.18829,
    y1: 43.7089,
    x2: 67.1877,
    y2: 82.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#208AC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7073_46",
    x1: 9.18829,
    y1: 43.7089,
    x2: 67.1877,
    y2: 82.0922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#208AC6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7073_46"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 68,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoVtAdmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-VT-admin.f4181de80c153abc3744dc1d1cc90a52.svg";